import React from 'react';
import styles from './style.module.scss';

interface CardProps {
  children: React.ReactNode;
  classNames?: string;
}

export const Card = (props: CardProps) => {
  const { children, classNames, ...rest } = props;
  const containerClassNames = `${styles.card} ${classNames}`;
  return (
    <div className={containerClassNames} {...rest}>
      {children}
    </div>
  );
};
